import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";

export const DataBox = () => {
    return (
        <YhBox title="" >
            <DataTable />
        </YhBox>
    )
}